import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import Details from "../components/Details";
import useMerchantStore from "../../../stores/merchant";
import useCommonStore from "../../../stores/common";
import styles from "./styles.module.scss";

const MerchantDetailsOnly = ({ match }) => {
  const { id } = match.params;
  const setActiveAppId = useMerchantStore((state) => state.setActiveAppId);
  const setShowDetails = useCommonStore((state) => state.setShowDetails);
  const toggleExpandDetails = useCommonStore(
    (state) => state.toggleExpandDetails,
  );

  useEffect(() => {
    if (!id) return;

    setActiveAppId(Number(id));
    setShowDetails(true);
    if (!useCommonStore.getState().expandDetails) {
      toggleExpandDetails();
    }

    return () => {
      setActiveAppId(null);
      setShowDetails(false);
      if (useCommonStore.getState().expandDetails) {
        toggleExpandDetails();
      }
      useMerchantStore.getState().reset();
    };
  }, [id]);

  return (
    <div className={styles.detailsOnlyContainer}>
      <Details isDetailsOnly={true} />
    </div>
  );
};

export default withRouter(MerchantDetailsOnly);
